import type { MessageCategory, SendTimesSettings, Weekday } from 'app/types/workflows'
import { WEEKDAYS } from './workflowSettings'

const WEEKDAY_ORDER: Weekday[] = WEEKDAYS.map((day) => day.value)
const WORKWEEK: Weekday[] = [`mon`, `tue`, `wed`, `thu`, `fri`]

/** "08:00" → "8:00 AM". */
export function formatClock(value: string): string {
  const [h, m] = value.split(`:`).map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return value
  const hour12 = h % 12 === 0 ? 12 : h % 12
  return `${hour12}:${String(m).padStart(2, `0`)} ${h < 12 ? `AM` : `PM`}`
}

function daysPhrase(days: Weekday[]): string {
  const chosen = WEEKDAY_ORDER.filter((day) => days.includes(day))
  if (chosen.length === 7) return `every day`
  if (chosen.length === 5 && WORKWEEK.every((day) => chosen.includes(day))) return `weekdays`
  if (chosen.length === 0) return `no days`
  return chosen.map((day) => WEEKDAYS.find((d) => d.value === day)!.label.slice(0, 3)).join(`, `)
}

/** One line for the send window, read back from the workflow's settings so a step never has to
 *  render the policy's controls (design language rule 6). */
export function sendWindowSummary(sendTimes: SendTimesSettings): string {
  if (!sendTimes.restrict) return `Any time. Late sends are skipped, not held.`
  const zone = sendTimes.contactTimezone ? `contact's time zone` : `practice time zone`
  return `${formatClock(sendTimes.start)} to ${formatClock(sendTimes.end)}, ${daysPhrase(sendTimes.days)}, ${zone}`
}

/** One line for the texting category and who it reaches. Takes the EFFECTIVE category (see
 *  effectiveCategory), so the toolbar chip and the step read-back cannot say different things. */
export function categorySummary(category: MessageCategory): string {
  return category === `marketing`
    ? `Marketing. Reaches opted-in contacts only.`
    : `Transactional. Reaches everyone with a number.`
}
